module.exports = __webpack_public_path__ + "img/freelancer.aff3bab6.jpg";